(() => {
  'use strict';

  const SELECTOR = '[data-lppp]';
  const MOBILE_QUERY = '(max-width: 820px)';
  const instances = new WeakMap();

  class LPPurchasePromise {
    constructor(root) {
      this.root = root;
      this.panels = Array.from(root.querySelectorAll('[data-lppp-panel]'));
      this.mediaQuery = window.matchMedia(MOBILE_QUERY);
      this.abortController = new AbortController();

      this.onToggle = this.onToggle.bind(this);
      this.onViewportChange = this.onViewportChange.bind(this);

      this.root.classList.add('is-enhanced');
      this.bind();
      this.syncPanels();
    }

    bind() {
      this.panels.forEach((panel) => {
        panel.querySelector('[data-lppp-toggle]')?.addEventListener('click', this.onToggle, {
          signal: this.abortController.signal
        });
      });

      if (typeof this.mediaQuery.addEventListener === 'function') {
        this.mediaQuery.addEventListener('change', this.onViewportChange, {
          signal: this.abortController.signal
        });
      } else {
        this.mediaQuery.addListener(this.onViewportChange);
      }
    }

    destroy() {
      this.abortController.abort();

      if (typeof this.mediaQuery.removeEventListener !== 'function') {
        this.mediaQuery.removeListener(this.onViewportChange);
      }

      this.root.classList.remove('is-enhanced');
    }

    onToggle(event) {
      if (!this.mediaQuery.matches) return;

      const button = event.currentTarget;
      const panel = button.closest('[data-lppp-panel]');
      const body = panel?.querySelector('[data-lppp-body]');

      if (!panel || !body) return;

      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      body.hidden = expanded;
    }

    onViewportChange() {
      this.syncPanels();
    }

    syncPanels() {
      const isMobile = this.mediaQuery.matches;

      this.panels.forEach((panel, index) => {
        const button = panel.querySelector('[data-lppp-toggle]');
        const body = panel.querySelector('[data-lppp-body]');

        if (!button || !body) return;

        if (!isMobile) {
          button.setAttribute('aria-expanded', 'true');
          body.hidden = false;
          return;
        }

        const shouldOpen = index === 0;
        button.setAttribute('aria-expanded', String(shouldOpen));
        body.hidden = !shouldOpen;
      });
    }
  }

  function init(scope = document) {
    scope.querySelectorAll?.(SELECTOR).forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new LPPurchasePromise(root));
    });
  }

  function destroy(scope) {
    scope.querySelectorAll?.(SELECTOR).forEach((root) => {
      instances.get(root)?.destroy();
      instances.delete(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
